import { render, staticRenderFns } from "./Semaforo2.vue?vue&type=template&id=96a31558"
import script from "./Semaforo2.vue?vue&type=script&lang=js"
export * from "./Semaforo2.vue?vue&type=script&lang=js"
import style0 from "./Semaforo2.vue?vue&type=style&index=0&id=96a31558&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports